import { render, staticRenderFns } from "./choose-province.vue?vue&type=template&id=4a3669bc&scoped=true&"
import script from "./choose-province.vue?vue&type=script&lang=js&"
export * from "./choose-province.vue?vue&type=script&lang=js&"
import style0 from "./choose-province.vue?vue&type=style&index=0&id=4a3669bc&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a3669bc",
  null
  
)

export default component.exports